/**
 * This class is used to create FnCheckboxFilterItem List Objects.
 */
export class FnCheckboxFilterItem {
  /**
   * member variable of Type string
   * used to uniquely identify the item from List of Item in DropDown List.
   */
  id: string;
  /**
   * member variable of Type string
   * used to show to item description on dropdown List
   */
  description: string;
  /**
   * member variable of Type boolen
   * if true then item is selected and it's all children also selected and when false item is not selected
   * and some children may or may not be selected but not all children selected.
   */
  isSelected?: boolean;
  /**
   * optional member Variable of Array type of FnCheckboxFilterItem.
   * used to show the child Items of current Item when grouping is true.
   */
  childArray?: Array<FnCheckboxFilterItem>;
}
